<template>
  <div id="school" :style="{width:width}">
    <!-- 头部导航部分 -->
    <HomeHeader />
    <!-- banner -->
    <div style="padding-top: 70px;width: 100%;margin: 0 auto;">
      <img src="@/assets/img/home/school_banner.jpg" alt="" width="100%" height=""/>
    </div>
    <!-- 检索&&标签 -->
    <el-row class="search_body" style="margin-top: 20px;">
      <!-- <el-col class="classType" :span="24">
        <div class="tag-group">
          <span class="tag-group__title" style="font-size: 20px;">课程类型：</span>
          <el-tag effect="dark" style="font-size: 12px;">{{ onActiveName }}</el-tag>
        </div>
      </el-col> -->
      <div @click="goMeta('all','全部')" :class="onActive === 'all'?'itemCellActive itemCell':'itemCell'">全部</div>
      <div v-for="item in tagsList" @click="goMeta(item.tagId,item.tagName)" :key="item.tagId" :class="onActive === item.tagId?'itemCellActive itemCell':'itemCell'" >{{item.tagName}}</div>
      <el-popover
        placement="bottom"
        width="400"
        trigger="click">
        <el-button v-for="item in moreTagsList" :class="onActive === item.tagId?'itemCellActive':'itemCell'" :key="item.tagId" type="text" @click="goMeta(item.tagId,item.tagName)">
          {{item.tagName}}
        </el-button>
        <!-- <el-button class="itemCell" type="text" slot="reference">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button> -->
      </el-popover>
    </el-row>
    <!-- 内容 -->
    <div class="list_body">
      <ul v-if="pageinfo.totalCount > 0">
        <li class="items" v-for="item in list" :key="item" @click="goNext(item.contentId)">
          <span class="red_dot" v-if="!item.isRead"></span>
          <img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="" width="400" height="280"/>
          <div class="list_item">
            <div class="item_title">{{item.title}}</div>
            <div class="item_content">{{item.description}}</div>
            <div class="item_time">
              <img src="@/assets/img/home/tiem.png" alt=""/>
              <span style="vertical-align: middle;">{{item.updateTime}}</span>
            </div>
            <!-- <el-row style="margin-bottom: 10px;">
              <el-col :span="24" style="text-align: left;">
                <div v-for="data in item.tags" :key="data.tagId" class="classType_text">{{ data.tagName }}</div>
              </el-col>
            </el-row> -->
          </div>
        </li>
      </ul>
      <div class="noData" v-else>暂无数据</div>
    </div>
    <!-- 分页 -->
    <div style="width: 1340px;margin: 0 auto;text-align: center;margin-top:96px;" v-if="pageinfo.totalCount !== 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="defaultPage"
        :page-size="12"
        layout="prev, pager, next"
        :total="pageinfo.totalCount">
      </el-pagination>
      <div style="display: inline-block;line-height: 28px;font-size: 12px;vertical-align: top;color:#999;">
        共{{pageinfo.totalCount}}条&nbsp;
        到第
        <input class="pageNum" v-model="pageNumber" type="number">
        页
        <el-button type="primary" style="font-size: 12px;" @click="changePage" class="professional_btn">确认</el-button>
      </div>
    </div>
    <!-- 底部组件 -->
    <HomeFooter style="margin-top: 78px;"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import { getInformationList, getTags } from '@/api/modules/Information'
export default {
  name: 'School',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      pageNumber: '',
      defaultPage: 1,
      searchString: '',
      list: [],
      pageinfo: {},
      pageIndex: 1,
      onActive: 'all',
      onActiveName: '全部',
      tagsList: [],
      moreTagsList: [],
      showMoreView: false
    }
  },
  created() {
    this.getList('all', '全部')
    this.get2Tags()
  },
  methods: {
    goMeta(searchString, tagname) {
      this.pageIndex = 1
      this.getList(searchString, tagname)
    },
    async getList(searchString, tagname) {
      this.onActive = searchString
      this.onActiveName = tagname
      this.list = []
      const obj = {
        pageIndex: this.pageIndex,
        pageSize: 12,
        groupId: '21803',
        tags: []
      }
      if (searchString === 'all') {
        obj.tags = []
      }
      else {
        obj.tags.push(searchString)
      }
      const res = await getInformationList(obj)
      if (res.code === 0) {
        var arr = JSON.parse(localStorage.getItem('schoolArray'))
        if (arr === null) {
          arr = []
        }
        if (res.data.dataList !== undefined) {
          res.data.dataList.forEach(ele => {
            ele.updateTime = this.timestampToTime(ele.updateTime)
            const indexNum = arr.indexOf(ele.contentId)
            if (indexNum > -1) {
              ele.isRead = true
            }
            else {
              ele.isRead = false
            }
          })
        }
        this.list = res.data.dataList
        this.pageinfo = res.data.page
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        return
      }
    },
    async get2Tags() {
      const obj = {
        pageSize: 1000,
        status: 1,
        tagGroupId: '1035209012363575296'
      }
      await getTags(obj).then((res) => {
        console.log(res)
        var dataList = []
        var moreDataList = []
        var dataArray = res.data.dataList
        for (let index = 0; index < dataArray.length; index++) {
          // if (index < 4) {
          dataList.push(dataArray[index])
          // }
          // else {
          //   moreDataList.push(dataArray[index])
          // }
        }
        this.tagsList = dataList
        this.moreTagsList = moreDataList
        if (this.moreTagsList.length === 0) {
          this.showMoreView = false
        }
        else {
          this.showMoreView = true
        }
      })
    },
    handleSizeChange(val) {
      this.pageIndex = val
      this.getList(this.onActive, this.onActiveName)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getList(this.onActive, this.onActiveName)
    },
    changePage() {
      const maxPage = Math.ceil(this.pageinfo.totalCount / 9)
      if (this.pageNumber > maxPage) {
        this.pageNumber = maxPage
      }
      if (this.pageNumber === '') {
        this.pageIndex = 1
      }
      else {
        this.pageIndex = this.pageNumber
      }
      this.defaultPage = this.pageNumber
      this.getList(this.onActive, this.onActiveName)
    },
    goNext(id) {
      var arr = JSON.parse(localStorage.getItem('schoolArray'))
      if (arr === null) {
        arr = []
      }
      arr.push(id)
      window.localStorage.setItem('schoolArray', JSON.stringify(arr))
      this.$router.push({
        name: 'schoolDetail',
        query: {
          id: id
        }
      })
    },
    timestampToTime(timestamp) {
      const date = new Date(timestamp)
      var Y = date.getFullYear() + '年'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
      var D = date.getDate() + '日'
      var h = date.getHours() + ':'
      var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds()
      return Y + M + D + h + m + s
    }
  }
}
</script>

<style lang="less" scoped>
// 检索
.search_body{
  width: 1340px;
  text-align: left;
  padding: 20px 0;
  margin: 0 auto;
  div{
    cursor:pointer;
    display: inline-block;
    font-weight: 400;
    color: #999999;
    transition: all .2s;
    margin:0 20px;
  }
  .class_active{
    color: #2F374B !important;
  }
}
/deep/.el-input__inner{
  padding-left:30px;
}
// 内容
.list_body{
  width:1340px;
  margin:0 auto;
  min-height: 489px;
  ul{
    margin:0;
    padding:0;
  }
  ul li {
    list-style: none;
    width:394px;
    display: inline-block;
    margin-top:40px;
    transition: all .5s;
    background: #FFFFFF;
    border: 1px solid #DDD;
    box-shadow: 6px 34px 46px 0px rgba(95,103,133,0.11);
    border-radius: 4px;
    position: relative;
    img{
      width:100%;
      vertical-align: middle;
    }
  }
}
.items:hover{
  border: 1px solid #4874F7;
  cursor:pointer;
}
.list_body ul li:nth-child(1){
  margin-top: 26px;
}
.list_body ul li:nth-child(2){
  margin:26px 66px 0 66px;
}
.list_body ul li:nth-child(3){
  margin-top: 26px;
}
.list_body ul li:nth-child(5){
  margin: 0 66px;
}
.list_body ul li:nth-child(8){
  margin: 0 66px;
}
.list_body ul li:nth-child(11){
  margin: 0 66px;
}
.list_item{
  .item_title{
    font-size: 19px;
    font-weight: 400;
    color: #000000;
    margin:0px 16px 14px 16px;
    padding-top:20px;
    white-space : normal;
    transition: all .5s;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .item_content{
    height:20px;
    overflow: hidden;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    margin:0 16px;
    transition: all .5s;
    text-overflow: ellipsis;
    white-space: nowrap;
    /deep/p{
      margin:0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
  .item_time{
    line-height: 32px;
    margin:0px 16px;
    padding: 14px 0;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    position: relative;
    img{
      width:14px;
      margin-right:6px;
    }
    div{
      display: inline-block;
    }
  }
}
// 分页
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color:white ;
  background: #4D78FF;
}
/deep/.el-pagination button:hover {
  color:white ;
  background: #4D78FF !important;
}
/deep/.el-pagination{
  display: inline-block;
  padding: 0;
  vertical-align: top;
}
/deep/.el-pager li{
  border: 1px solid #E5E5E5;
  border-radius: 4px !important;
  margin: 0 3px !important;
  font-weight: 400;
  color:#999999;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background: none;
}
.pageNum{
  width: 22px;
  height: 24px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
}
.pageNum:focus {
  outline:none;
  border: 1px solid #E5E5E5;
}
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
}
input[type="number"]{
  -moz-appearance:textfield;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #4D78FF;
  color: #FFF;
}
.professional_btn{
  width: 46px;
  height: 28px;
  background: #FFFFFF;
  border: 1px solid #4D78FF;
  border-radius: 4px;
  color: #4D78FF;
  padding: 0;
  transition: all .2s;
}
.professional_btn:hover{
  background: #4D78FF;
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
}
.noData{
  text-align: center;
  padding: 50px 0;
  line-height: 50px;
  font-size: 24px;
  color:#DDD;
}
.red_dot{
  display: inline-block;
  width:6px;
  height:6px;
  border-radius: 6px;
  background: red;
  position: absolute;
  right: 5px;
  top: 5px;
}
.classType{
  text-align: left !important;
  margin: 10px 0px !important;
  height: 32px;
}
.itemCell{
  font-size: 16px;
  color: #999;
  display: inline-block;
  margin-left: 20px;
  user-select: none;
  -webkit-user-select: none;
}
.itemCellActive{
  font-size: 16px;
  color: #409eff !important;
  display: inline-block;
  margin-left: 20px;
  user-select: none;
  -webkit-user-select: none;
}
.classType_text{
  background: #FEF7EE;
  border: 1px solid #EFA13E;
  border-radius: 16px;
  font-weight: 400;
  color: #EFA13E;
  padding:8px 14px;
  line-height: 16px;
  display: inline-block;
  margin-left: 10px;
}
</style>
